import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AlertCircleIcon } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Sales al pasillo y empieza el llanto', 'Cierras una puerta y rasca', 'Bajas la basura y hay ladridos', 'Intentas "hacerlo bien" y solo te sientes peor'];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    visible: {
      opacity: 1,
      x: 0
    }
  };
  return <section className="w-full bg-white py-16 md:py-24 px-4" data-id="element-100">
      <div className="max-w-4xl mx-auto" data-id="element-101">
        <motion.h2 className="text-3xl md:text-4xl font-bold text-[#2C2C2C] mb-8 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-102">
          El problema real no es que te siga…
        </motion.h2>

        <motion.p className="text-xl text-[#5C5C5C] mb-12 text-center max-w-2xl mx-auto" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} data-id="element-103">
          Es que cuando no te ve, su cerebro completa la historia por su cuenta.
          <br data-id="element-104" />
          <strong className="text-[#2C2C2C]" data-id="element-105">
            Y la historia suele ser: "me dejaron".
          </strong>
        </motion.p>

        <motion.div className="bg-[#FBF9F6] rounded-2xl p-8 md:p-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-106">
          <h3 className="text-2xl font-bold text-[#2C2C2C] mb-6" data-id="element-107">
            Por eso pasa lo típico:
          </h3>
          <motion.ul className="space-y-4" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} data-id="element-108">
            {problems.map((problem, index) => <motion.li key={index} className="flex items-start" variants={itemVariants} data-id="element-109">
                <AlertCircleIcon className="h-6 w-6 text-[#C7E0E7] mr-3 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-110" />
                <span className="text-lg text-[#2C2C2C]" data-id="element-111">{problem}</span>
              </motion.li>)}
          </motion.ul>

          <motion.div className="mt-8 pt-8 border-t border-[#C7E0E7]/20" initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} data-id="element-112">
            <p className="text-lg text-[#5C5C5C] italic" data-id="element-113">
              Y encima… se te mete una culpa silenciosa:
            </p>
            <p className="text-lg text-[#2C2C2C] mt-3 font-medium" data-id="element-114">
              "Si lo entreno, ¿lo estoy dañando?"
              <br data-id="element-115" />
              "Si lo dejo llorar, ¿soy mala persona?"
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}